import { useRef } from 'react'
import ResourceSelectionGallery, {
  GalleryRefHandle,
} from '../../../authenticated/components/ResourceSelectionGallery'
import { Home, Thermostat, Vehicle, VehicleCharger } from '@/types'
import { DeviceSelection } from './DeviceSelectionGallery.types'
import { useViewModel } from './useViewModel'
import { EnergySystem } from '@/types/energySystem'

export type Props = {
  vehicles: Vehicle[]
  homes: Home[]
  thermostats: Thermostat[]
  vehicleChargers: VehicleCharger[]
  energySystems: EnergySystem[]
  selectedDevice: DeviceSelection | null
  setSelectedDevice: (device: DeviceSelection) => void
}

export default function DeviceSelectionGallery(props: Props) {
  const viewModel = useViewModel(props)
  const galleryControlsRef = useRef<GalleryRefHandle>(null)

  const resources = [
    ...viewModel.galleryActions,
    ...viewModel.sortedDevices.map((d) => d.resource),
  ]
  const selectedDevice = viewModel.sortedDevices.find(
    (d) => String(d.id) === String(props.selectedDevice?.id),
  )

  return (
    <>
      <ResourceSelectionGallery
        resources={resources}
        ref={galleryControlsRef}
      />

      {selectedDevice && selectedDevice.alertState.mode !== 'none' && (
        <div>{selectedDevice.alertState.renderBanner()}</div>
      )}
    </>
  )
}
